import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export const useMutationSendSMSToMember = ({ api }: { api: ApiType }) => {
  return useMutation({
    mutationFn: (
      payload: Parameters<ApiType["smsApi"]["sendSMSToMember"]>[0],
    ) => api.smsApi.sendSMSToMember(payload),
  });
};
